import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Placeholder from '../../../../components/Placeholder';
import Image from '../../../../components/ContentfulImage';
import updateDiagnosisResult from '../../../../redux/actions/diagnosisResult';
import DiagnosisResultHomeCareItemListCard from '../DiagnosisResultHomeCareItemListCard/DiagnosisResultHomeCareItemListCard';
import CareMenuImage from '../CareMenuImage/CareMenuImage';
import { CATEGORY_HAIRCARE, CATEGORY_SCALPCARE, CATEGORY_HAIR_SCALP_CARE } from '../CareMenuImage/CareMenuImageConst';

// import { Background, Container, Contents, Title, Navi } from '../Common/Common.style';
import { Background, Container, Contents, Navi } from '../Common/Common.style';
// import { Hr, Wrapper, CareMenu, HomeCare, OtherItems, Items, } from './SelectedCareMenuPage.style';
import { Wrapper, CareMenu, HomeCare, OtherItems, Items, SubTitle } from './SelectedCareMenuPage.style';

class SelectedCareMenuPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      selectedItemSlug: null,
      recommendedItemSlug: null,
      itemsInfo: [],
      selectedCategory: null,
      selectedType: null,
    };
  }

  getHomeCareItemsByType = (homeCareItems, type) => {
    const arr = [];
    homeCareItems.map(item => {
      if (item.type === type) {
        arr.push(item);
      }
    });
    return arr || null;
  };

  handleSelectItem = (category, type, slug) => {
    const { selectedHomeCareHairItems, selectedHomeCareScalpItems, homeCareHairItems, homeCareScalpItems } = this.props;
    if (category === CATEGORY_HAIRCARE) {
      homeCareHairItems.map(homeCareHairItem => {
        if (homeCareHairItem.type === type && homeCareHairItem.slug === slug) {
          const arr = [];
          for (let i = 0, max = selectedHomeCareHairItems.length; i < max; i += 1) {
            if (selectedHomeCareHairItems[i].type === homeCareHairItem.type) {
              arr.push(homeCareHairItem);
            } else {
              arr.push(selectedHomeCareHairItems[i]);
            }
          }
          this.props.updateDiagnosisResult({
            selectedHomeCareHairItems: arr,
          });
        }
      });
    } else if (category === CATEGORY_SCALPCARE) {
      homeCareScalpItems.map(homeCareScalpItem => {
        if (homeCareScalpItem.type === type && homeCareScalpItem.slug === slug) {
          const arr = [];
          for (let i = 0, max = selectedHomeCareScalpItems.length; i < max; i += 1) {
            if (selectedHomeCareScalpItems[i].type === homeCareScalpItem.type) {
              arr.push(homeCareScalpItem);
            } else {
              arr.push(selectedHomeCareScalpItems[i]);
            }
          }
          this.props.updateDiagnosisResult({
            selectedHomeCareScalpItems: arr,
          });
        }
      });
    }
  };

  handleOpenModal = (itemsInfo, selectedItemSlug, recommendedItemSlug, selectedCategory, selectedType) => {
    this.setState({
      isOpen: true,
      itemsInfo,
      selectedItemSlug,
      recommendedItemSlug,
      selectedCategory,
      selectedType,
    });
    if (this.props.handleOpenModal) this.props.handleOpenModal();
  };

  handleCloseModal = () => {
    this.setState({
      isOpen: false,
      itemsInfo: [],
      selectedItemSlug: null,
      recommendedItemSlug: null,
      selectedCategory: null,
      selectedType: null,
    });
    if (this.props.handleCloseModal) this.props.handleCloseModal();
  };

  renderCareMenu = (selectedCare, category) => {
    // const { copy, changeCurrentScene } = this.props;
    const { copy } = this.props;
    // const sublimicDiagnosisResultsCopy = copy.sublimicDiagnosisResults;
    return (
      <div className="care-menu__box">
        <div className="care-menu__box-left">
          <div className="care-menu__image">
            <CareMenuImage category={category} />
          </div>
        </div>
        <div className="care-menu__box-right">
          <h1 className="care-menu__heading">
            {(selectedCare.title && this.renderTitle(selectedCare.title)) || <Placeholder w="300px" h="45px" />}
          </h1>
          <p className="care-menu__paragraph">
            <span>
              {(selectedCare.salonSetting && `${selectedCare.salonSetting.displayName} : `) || (
                <Placeholder w="143px" h="19px" />
              )}
            </span>
            <span>
              {selectedCare.salonSetting &&
                selectedCare.salonSetting.operationTime &&
                `${selectedCare.salonSetting.operationTime || 0} ${copy.common.minute || ''} `}
              {selectedCare.salonSetting &&
                selectedCare.salonSetting.price && (
                  <React.Fragment>{this.renderPrice(selectedCare.salonSetting.price)}</React.Fragment>
                )}
            </span>
          </p>
          <div className="care-menu__box2">
            <div className="care-menu__image">
              <CareMenuImage category={category} />
            </div>
          </div>
          {/* <button
            className="care-menu__button"
            type="button"
            onClick={e => {
              e.preventDefault();
              if (changeCurrentScene) changeCurrentScene('care');
            }}
          >
            {(sublimicDiagnosisResultsCopy &&
              sublimicDiagnosisResultsCopy.HomeCare &&
              sublimicDiagnosisResultsCopy.HomeCare.changeCtaLabel) || <Placeholder w="50px" h="14px" />}
          </button> */}
        </div>
      </div>
    );
  };

  renderTitle = title => {
    const tits = title.split('、');
    return tits.map((e, i) => (i === tits.length - 1 ? <div key={i}>{e}</div> : <div key={i}>{`${e}、`}</div>));
  };

  renderPrice = price => {
    const { locale, authSalonSettingData } = this.props;
    if (
      price &&
      authSalonSettingData &&
      authSalonSettingData.basicSettings &&
      authSalonSettingData.basicSettings.currencyCode
    ) {
      const localeName = locale.split('_')[0];
      const currencyName = authSalonSettingData.basicSettings.currencyCode;
      return new Intl.NumberFormat(localeName, { style: 'currency', currency: currencyName }).format(price);
    }
    return null;
  };

  renderButton = (selectedHomeCareItems, recommendedHomeCareItems, homeCareItems, category, type) => {
    const { copy } = this.props;
    const sublimicDiagnosisResultsCopy = copy.sublimicDiagnosisResults;
    let selectedItemSlug = null;
    selectedHomeCareItems.map(selectedHomeCareItem => {
      if (selectedHomeCareItem.type === type) {
        selectedItemSlug = selectedHomeCareItem.slug;
      }
    });
    let recommendedItemSlug = null;
    recommendedHomeCareItems.map(recommendedHomeCareItem => {
      if (recommendedHomeCareItem.type === type) {
        recommendedItemSlug = recommendedHomeCareItem.slug;
      }
    });
    const arr = this.getHomeCareItemsByType(homeCareItems, type) || null;
    if (arr && arr.length >= 2) {
      return (
        <button
          className="items__button"
          type="button"
          onClick={e => {
            e.preventDefault();
            const arr = this.getHomeCareItemsByType(homeCareItems, type) || null;
            if (arr && arr.length >= 2) {
              this.handleOpenModal(arr, selectedItemSlug, recommendedItemSlug, category, type);
            }
          }}
        >
          {(sublimicDiagnosisResultsCopy &&
            sublimicDiagnosisResultsCopy.HomeCare &&
            sublimicDiagnosisResultsCopy.HomeCare.changeCtaLabel) || <Placeholder w="50px" h="14px" />}
        </button>
      );
    }
    return <div className="items__spacer" />;
  };

  renderHomeCareItem = (selectedHomeCareItems, category) => {
    const {
      homeCareHairItems,
      homeCareScalpItems,
      homeCareCategory,
      recommendedHomeCareHairItems,
      recommendedHomeCareScalpItems,
    } = this.props;
    return selectedHomeCareItems.map((careItem, index) => {
      if (careItem.type && careItem.type.indexOf('Wonder Shield') >= 0) return null;
      return (
        <dl className="items__list-dl" key={index}>
          <dt>{homeCareCategory[careItem.type.replace(' ', '').replace('-', '')] || ''}</dt>
          <dd>
            <div className="items__image">
              {careItem && careItem.product && careItem.product.variants && careItem.product.variants[0].image ? (
                <Image src={careItem.product.variants[0].image} options={{ w: '130px', h: '130px' }} />
              ) : (
                <Placeholder w="130px" h="130px" />
              )}
            </div>
            {category === CATEGORY_HAIRCARE &&
              this.renderButton(
                selectedHomeCareItems,
                recommendedHomeCareHairItems,
                homeCareHairItems,
                CATEGORY_HAIRCARE,
                careItem.type
              )}
            {category === CATEGORY_SCALPCARE &&
              this.renderButton(
                selectedHomeCareItems,
                recommendedHomeCareScalpItems,
                homeCareScalpItems,
                CATEGORY_SCALPCARE,
                careItem.type
              )}
            <p className="items__paragraph">{careItem.product.name}</p>
          </dd>
        </dl>
      );
    });
  };

  renderWonderShield = selectedHomeCareItems => {
    const { homeCareCategory } = this.props;
    return selectedHomeCareItems.map((careItem, index) => {
      if (careItem.type && careItem.type.indexOf('Wonder Shield') >= 0) {
        return (
          <div className="other-items__box" key={index}>
            <div className="other-items__box-left">
              <div className="other-items__image">
                {careItem && careItem.product && careItem.product.variants && careItem.product.variants[0].image ? (
                  <Image src={careItem.product.variants[0].image} options={{ w: '130px', h: '130px' }} />
                ) : (
                  <Placeholder w="130px" h="130px" />
                )}
              </div>
            </div>
            <div className="other-items__box-right">
              <h2 className="other-items__heading2">
                {homeCareCategory[careItem.type.replace(' ', '').replace('-', '')] || ''}
              </h2>
              <p className="other-items__paragraph">{careItem.product.name}</p>
            </div>
          </div>
        );
      }
      return null;
    });
  };

  render() {
    const {
      copy,
      selectedHairCare,
      selectedScalpCare,
      selectedHomeCareHairItems,
      selectedHomeCareScalpItems,
      selectedCareMenu,
      changeCurrentScene,
    } = this.props;
    console.log('@ SelectedCareMenuPage', this.props);
    const sublimicDiagnosisResultsCopy = copy.sublimicDiagnosisResults;

    const renderHomeCareScalpItem = (selectedHomeCareHairItems, selectedHomeCareScalpItems) => {
      let flg = true;
      if (selectedHomeCareHairItems && selectedHomeCareHairItems.length >= 1) {
        selectedHomeCareHairItems.map(item => {
          if (item.type === 'Shampoo') {
            flg = false;
          }
        });
      }
      if (flg) {
        return this.renderHomeCareItem(selectedHomeCareScalpItems, CATEGORY_SCALPCARE);
      }
      return this.renderHomeCareItem(
        selectedHomeCareScalpItems.filter(item => item.type !== 'Shampoo'),
        CATEGORY_SCALPCARE
      );
    };

    return (
      <Background>
        <Container>
          {/* <Title>
            {(sublimicDiagnosisResultsCopy &&
              sublimicDiagnosisResultsCopy.HomeCare &&
              sublimicDiagnosisResultsCopy.HomeCare.title) || <Placeholder w="300px" h="30px" />}
          </Title>
          <Hr /> */}
          <Contents>
            <Wrapper>
              <SubTitle>
                <div className="sub-title__box-left">
                  <h1 className="sub-title__heading">
                    {(sublimicDiagnosisResultsCopy &&
                      sublimicDiagnosisResultsCopy.HomeCare &&
                      sublimicDiagnosisResultsCopy.HomeCare.title) || <Placeholder w="50px" h="14px" />}
                  </h1>
                </div>
                <div className="sub-title__box-right">
                  <button
                    className="sub-title__button"
                    type="button"
                    onClick={e => {
                      e.preventDefault();
                      if (changeCurrentScene) changeCurrentScene('care');
                    }}
                  >
                    {(sublimicDiagnosisResultsCopy &&
                      sublimicDiagnosisResultsCopy.HomeCare &&
                      sublimicDiagnosisResultsCopy.HomeCare.changeCtaLabel) || <Placeholder w="50px" h="14px" />}
                  </button>
                </div>
              </SubTitle>
              <CareMenu>
                {(selectedCareMenu === CATEGORY_HAIRCARE || selectedCareMenu === CATEGORY_HAIR_SCALP_CARE) &&
                  this.renderCareMenu(selectedHairCare, CATEGORY_HAIRCARE)}
                {(selectedCareMenu === CATEGORY_SCALPCARE || selectedCareMenu === CATEGORY_HAIR_SCALP_CARE) &&
                  this.renderCareMenu(selectedScalpCare, CATEGORY_SCALPCARE)}
              </CareMenu>
              <HomeCare>
                <h1 className="home-care__heading">
                  {(sublimicDiagnosisResultsCopy &&
                    sublimicDiagnosisResultsCopy.HomeCare &&
                    sublimicDiagnosisResultsCopy.HomeCare.selectText) || <Placeholder w="100px" h="20px" />}
                </h1>
                <Items>
                  {(selectedCareMenu === CATEGORY_HAIRCARE || selectedCareMenu === CATEGORY_HAIR_SCALP_CARE) &&
                    this.renderHomeCareItem(selectedHomeCareHairItems, CATEGORY_HAIRCARE)}
                  {selectedCareMenu === CATEGORY_SCALPCARE &&
                    this.renderHomeCareItem(selectedHomeCareScalpItems, CATEGORY_SCALPCARE)}
                  {selectedCareMenu === CATEGORY_HAIR_SCALP_CARE &&
                    renderHomeCareScalpItem(selectedHomeCareHairItems, selectedHomeCareScalpItems)}
                </Items>
              </HomeCare>
              <OtherItems>
                <h1 className="other-items__heading">
                  {(sublimicDiagnosisResultsCopy &&
                    sublimicDiagnosisResultsCopy.HomeCare &&
                    sublimicDiagnosisResultsCopy.HomeCare.otherItemText) || <Placeholder w="100px" h="20px" />}
                </h1>
                {selectedCareMenu === CATEGORY_HAIRCARE && this.renderWonderShield(selectedHomeCareHairItems)}
                {selectedCareMenu === CATEGORY_SCALPCARE && this.renderWonderShield(selectedHomeCareScalpItems)}
                {selectedCareMenu === CATEGORY_HAIR_SCALP_CARE && this.renderWonderShield(selectedHomeCareHairItems)}
                {selectedCareMenu === CATEGORY_HAIRCARE && (
                  <div className="other-items__box2">
                    <Items>
                      {this.renderHomeCareItem(
                        selectedHomeCareScalpItems.filter(item => item.type !== 'Shampoo'),
                        CATEGORY_SCALPCARE
                      )}
                    </Items>
                  </div>
                )}
                {selectedCareMenu === CATEGORY_SCALPCARE && (
                  <div className="other-items__box2">
                    <Items>
                      {this.renderHomeCareItem(
                        selectedHomeCareHairItems.filter(item => item.type !== 'Shampoo'),
                        CATEGORY_HAIRCARE
                      )}
                    </Items>
                  </div>
                )}
              </OtherItems>
            </Wrapper>
          </Contents>
          <Navi>
            <button
              className="navi__button"
              type="button"
              onClick={e => {
                e.preventDefault();
                if (changeCurrentScene) changeCurrentScene('confirm');
              }}
            >
              {(sublimicDiagnosisResultsCopy &&
                sublimicDiagnosisResultsCopy.confirmation &&
                sublimicDiagnosisResultsCopy.confirmation.menuLinkText) || <Placeholder w="100px" h="16px" />}
            </button>
          </Navi>
          <DiagnosisResultHomeCareItemListCard
            isOpen={this.state.isOpen}
            handleSelectItem={this.handleSelectItem}
            handleCloseCard={this.handleCloseModal}
            selectedItemSlug={this.state.selectedItemSlug}
            recommendedItemSlug={this.state.recommendedItemSlug}
            itemsInfo={this.state.itemsInfo}
            selectedCategory={this.state.selectedCategory}
            selectedType={this.state.selectedType}
            selectedCareMenu={selectedCareMenu}
          />
        </Container>
      </Background>
    );
  }
}

SelectedCareMenuPage.defaultProps = {
  copy: {},
  homeCareCategory: {},
  authSalonSettingData: {},
  selectedScalpCare: {},
  selectedHairCare: {},
  selectedHomeCareHairItems: [],
  selectedHomeCareScalpItems: [],
  selectedCareMenu: CATEGORY_HAIRCARE,
  recommendedHomeCareHairItems: [],
  recommendedHomeCareScalpItems: [],
  homeCareHairItems: [],
  homeCareScalpItems: [],
  changeCurrentScene: null,
  handleOpenModal: null,
  handleCloseModal: null,
};
SelectedCareMenuPage.propTypes = {
  copy: PropTypes.shape({}),
  homeCareCategory: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  authSalonSettingData: PropTypes.shape({}),
  selectedScalpCare: PropTypes.shape({}),
  selectedHairCare: PropTypes.shape({}),
  // eslint-disable-next-line react/forbid-prop-types
  selectedHomeCareHairItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  selectedHomeCareScalpItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  selectedCareMenu: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  recommendedHomeCareHairItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  recommendedHomeCareScalpItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  homeCareHairItems: PropTypes.array,
  // eslint-disable-next-line react/forbid-prop-types
  homeCareScalpItems: PropTypes.array,
  changeCurrentScene: PropTypes.func,
  handleOpenModal: PropTypes.func,
  handleCloseModal: PropTypes.func,
  updateDiagnosisResult: PropTypes.func.isRequired,
};

const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  homeCareCategory: state.salonConsultaionSiteOptions.siteCopy.sublimicDiagnosisResults.HomeCare,
  locale: state.locale,
  diagnosisResult: state.diagnosisResult,
  authSalonSettingData: state.authSalonSettings,
  selectedScalpCare: state.diagnosisResult.selectedScalpCare,
  selectedHairCare: state.diagnosisResult.selectedHairCare,
  selectedHomeCareHairItems: state.diagnosisResult.selectedHomeCareHairItems,
  selectedHomeCareScalpItems: state.diagnosisResult.selectedHomeCareScalpItems,
  selectedCareMenu: state.diagnosisResult.selectedCareMenu,
  recommendedHomeCareHairItems: state.diagnosisResult.recommendedHomeCareHairItems,
  recommendedHomeCareScalpItems: state.diagnosisResult.recommendedHomeCareScalpItems,
});
const mapDispatch = dispatch => ({
  updateDiagnosisResult: data => dispatch(updateDiagnosisResult(data)),
});
export default connect(mapState, mapDispatch)(SelectedCareMenuPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/SelectedCareMenuPage/SelectedCareMenuPage.js